export const isMobileTest = (env, isMobile) => env && isMobile;
